import React from 'react';
import BrandLogo from '../logo/logo';
import PhoneCall from '../phone/PhoneCall';
import { NavMenu } from './navigation/menu';
import Link from '../link';
import useTranslation from '../../../../hooks/useTranslation';
import useMenu from '../../../../hooks/useMenu';
import useProduct from '../../../../hooks/useProduct';
import { EventPosition } from '../../../../services/analytics-interfaces';

export const Header = () => {
	const { t } = useTranslation();
	const { params } = useProduct();
	const { headerMenu } = useMenu();

	return (
		<header className="w-full flex flex-col print:hidden shadow-md">
			<div className="flex flex-1 justify-center lg:absolute lg:right-6 lg:bg-neutral pt-2 lg:py-1 lg:px-3 rounded-br-lg rounded-bl-lg text-xs lg:text-sm">
				<span>{t('pages.header.menu.usresidents')}</span>
			</div>
			<div className="py-5 px-6 max-w-6xl w-full lg:mx-auto flex-1 flex items-center justify-between gap-6">
				<div className="flex flex-1 justify-left lg:text-left">
					<Link
						href={params.website}
						rel="noopener noreferrer"
						title={t('header.logo')}
						position={EventPosition.Header}
						target="_blank">
						<BrandLogo />
					</Link>
				</div>
				<div className="flex items-center justify-end gap-5">
					<div className="hidden lg:flex lg:flex-1">
						<NavMenu items={headerMenu} />
					</div>
					{params.phoneNumber && (
						<div className="flex items-center">
							<PhoneCall
								shortText={t('header.call')}
								position={EventPosition.Header}
							/>
						</div>
					)}
				</div>
			</div>
			<div className="flex justify-center p-3 bg-neutral lg:hidden">
				<NavMenu items={headerMenu} />
			</div>
		</header>
	);
};

export default Header;
